/**
 * Woopra pageview tracking for Inertia (SPA) navigations.
 *
 * woopra-trk.js (loaded via partials/header-scripts.blade.php) fires a 'pv'
 * event on hard page loads only, so client-side navigations are not tracked
 * by it. The tracker returned by this factory fires the same 'pv' event for
 * each client-side navigation. The first call is skipped because Inertia
 * emits 'navigate' for the initial hard load, which woopra-trk.js already
 * tracked.
 */
export function createSpaPageviewTracker() {
    let initialNavigationSeen = false;

    /**
     * Track a single SPA navigation as a Woopra pageview.
     *
     * @param {string} pageUrl - URL of the visited page (path or absolute URL)
     * @returns {boolean} - true if a Woopra 'pv' event was sent
     */
    return function trackSpaPageview(pageUrl) {
        if (!initialNavigationSeen) {
            initialNavigationSeen = true;
            return false;
        }

        if (
            typeof window === 'undefined' ||
            typeof window.woopra === 'undefined'
        ) {
            return false;
        }

        let url = pageUrl || window.location.pathname;
        try {
            // Match the hard-load payload, which sends the pathname only
            url = new URL(url, window.location.origin).pathname;
        } catch (_) {
            // Keep the raw value if it can't be parsed as a URL
        }

        try {
            window.woopra.track('pv', {
                url,
                title: document.title,
                user_agent: navigator.userAgent,
            });
        } catch (_) {
            // Never let a third-party tracking failure break the caller
            // (the shared navigate handler also fires GTM/Meta/HubSpot)
            return false;
        }

        return true;
    };
}
